module.exports = __webpack_public_path__ + "static/media/20201121_220450_221_IMG_0990.0d03f6e2.jpg";